/* eslint-disable @typescript-eslint/no-explicit-any */
import { Delete, Get, Patch, Post } from "./apiHelper";
import { ApiResponse } from "../interfaces/Api";
import { IBiometricDevice } from "../interfaces/BiometricDeviceInterface";

const biometricDeviceRoot = "/api/biometricDevices";

// get biometric devices
export async function getBiometricDevices({
  resourceCentreId
}: {
  resourceCentreId: number;
}): Promise<ApiResponse<Array<IBiometricDevice>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", resourceCentreId.toString());

  const response = await Get(`${biometricDeviceRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<IBiometricDevice>>;
}

// post biometric device
export async function postBiometricDevice(
  data: Partial<IBiometricDevice>
): Promise<ApiResponse<IBiometricDevice>> {
  const response = await Post(`${biometricDeviceRoot}`, data as any, true);
  return response.data as ApiResponse<IBiometricDevice>;
}

// patch biometric device
export async function patchBiometricDevice({
  id,
  data
}: {
  id: number | string;
  data: Partial<IBiometricDevice>;
}): Promise<ApiResponse<IBiometricDevice>> {
  const response = await Patch(`${biometricDeviceRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<IBiometricDevice>;
}

// delete biometric device
export async function deleteBiometricDevice(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${biometricDeviceRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
